import {
  createApplyFunction,
  createBracketAutocompleteExtensions,
  SINGLE_BRACKET_CONFIG,
} from '../../html-editor/extensions/bracket-autocomplete';

import { getSupportedGroups } from '../buttons/field-replacement';
import { messages as fieldReplacementMessages, groupHeadingMessages } from '../buttons/field-replacement/messages';

import type { Completion } from '@codemirror/autocomplete';
import type { Extension } from '@codemirror/state';
import type { IntlShape } from 'react-intl';

export const createFieldAutocomplete = (intl: IntlShape, replacementSet: string): Extension[] => {
  const supportedGroups = getSupportedGroups(replacementSet);

  // Build all field options upfront
  const allFieldOptions: Completion[] = [];
  Object.entries(supportedGroups).forEach(([groupKey, fields]) => {
    const groupLabel = intl.formatMessage(groupHeadingMessages[groupKey as keyof typeof groupHeadingMessages]);
    fields.forEach((fieldKey) => {
      const message = fieldReplacementMessages[fieldKey as keyof typeof fieldReplacementMessages];
      if (!message) return;
      const fieldLabel = intl.formatMessage(message);
      allFieldOptions.push({
        label: fieldLabel,
        detail: groupLabel,
        apply: createApplyFunction(SINGLE_BRACKET_CONFIG, fieldLabel),
        type: 'variable',
      });
    });
  });

  return createBracketAutocompleteExtensions(SINGLE_BRACKET_CONFIG, allFieldOptions);
};
